import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import * as CredentialsActions from './credentials.actions';
import * as CredentialsSelectors from './credentials.selectors';

@Injectable()
export class CredentialsFacade {
    private readonly store = inject(Store);

    public readonly isMapsApiLoaded$: Observable<boolean> = this.store.select(CredentialsSelectors.selectMapsApiLoaded);
    public readonly mapsApiKey$: Observable<string> = this.store.select(CredentialsSelectors.selectMapsApiKey);

    public setMapsApiKey(apiKey: string): void {
        this.store.dispatch(CredentialsActions.setMapsApiKey({ apiKey }));
    }
}
